import { render, staticRenderFns } from "./OrgsNew.vue?vue&type=template&id=0da684fe&scoped=true"
import script from "./OrgsNew.vue?vue&type=script&lang=js"
export * from "./OrgsNew.vue?vue&type=script&lang=js"
import style0 from "./OrgsNew.vue?vue&type=style&index=0&id=0da684fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da684fe",
  null
  
)

export default component.exports